var ApplicantAPI = require("../../common/api/applicant");
var AuthStore = require("../../common/auth")
var OrganisationTypesAPI = require("../../common/api/organisationTypes");
var CharityRegistrationOrganisationsAPI = require("../../common/api/charityRegistrationOrganisations");
var ApplicantLegalStatusAPI = require("../../common/api/applicantLegalStatuses");
var UserAPI = require("../../common/api/user");
var enums = require('../../common/enums');
var Geo = require('../../common/geo');
var Category = require('../../common/category');
var Promise = require("bluebird");
var _ = require("underscore");

module.exports = function ApplicantRegistrationController($scope, $state, $document, $timeout, $location, ngDialog, $anchorScroll, $rootScope) {
  var vm = this;
  vm.organisationInformation = {};
  vm.submit = {};
  vm.applicantId = null;  
  vm.userId = $rootScope.auth.user_id;

  vm.clearNav = function() {
    vm.organisationInformationActive = true;
    vm.submitActive = false;
  };

  vm.accountType = enums.accountType;
  vm.NumberOfPeople = enums.NumberOfPeople;
  vm.NumberOfPeopleLarge = enums.NumberOfPeopleLarge;
  vm.OrganisationManagementType = enums.OrganisationManagementType;
  vm.SocialMediaType = enums.SocialMediaType;
  vm.yesOrNo = enums.YesOrNo;

  vm.OneYear = (new Date()).getFullYear() - 1;
  vm.TwoYear = (new Date()).getFullYear() - 2;
  vm.ThreeYear = (new Date()).getFullYear() - 3;

  vm.getDescription = function(enm, id){
    for (var i = 0; i < enm.length; i++) {
      var item = enm[i];
      if (item.id == id) return item.description;
    }
  }

  vm.goToTop = function(){
    $location.hash('pageTop');
    $anchorScroll();
  }

    var message = "Are you sure you want to navigate away from the applicant registration page? Any unsaved progress will be lost.";

    vm.preventNavigation = function(bool){
      if (bool === false) {
        window.onbeforeunload = null;
        vm.isPreventingNavigation = false;
        if (vm.stateChangePreventNav) {
          vm.stateChangePreventNav();
          delete vm.stateChangePreventNav;
        }
        return
      }

      vm.isPreventingNavigation = true;
      window.onbeforeunload = function(e) {
        e = e || window.event;

        if (e) {
          e.returnValue = message;
        }

        return message;
      };

      // return early if already set up
      if (vm.stateChangePreventNav) return;
      vm.stateChangePreventNav = $rootScope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
        e.preventDefault();
        vm.triggerPreventNavigation().then(function(){
          $state.go(toState, toParams);
        })
      })

    }

  vm.submitForm = function(opts) {
    opts = opts || {}
    if (opts.direction == "back"){
      if ($scope.pane < 1) return;
      $scope.pane = $scope.pane - 1;
    } else {
      if ($scope.pane > 6) return;
      $scope.pane = $scope.pane + 1;
    }
    var applicant = _.clone(vm.organisationInformation);
    // -CSH we're cloning here so we can delete the properties that we don't want to send to the server;
    applicant.applicantId = vm.applicantId;
    applicant.charityRegistrationOrganisationId = applicant.charityRegistrationOrganisation ? applicant.charityRegistrationOrganisation.id : null;
    delete applicant.charityRegistrationOrganisation;
    $scope.saving = true;
    return ApplicantAPI.SaveApplicant(applicant).then(function(result) {
      vm.organisationInformationActive = false;
      vm.submitActive = true;
      $location.path("applicant-registration#submit");
      window.location.hash = "submit";
      var applicantId = result.id;
      if (applicantId)
        vm.applicantId = applicantId;
      AuthStore.refresh();
    }).finally(function(){
      $scope.saving = false;
    });
  };

  vm.submitFinalForm = function(form) {
    vm.organisationInformation.isSubmitted = true;
    if (form) {
      form.triedToSubmit = true;
      if (!form.$valid)
        return 0;
    }
    var applicant = _.clone(vm.organisationInformation);
    // -CSH we're cloning here so we can delete the properties that we don't want to send to the server;
    applicant.applicantId = vm.applicantId;
    applicant.charityRegistrationOrganisationId = applicant.charityRegistrationOrganisation ? applicant.charityRegistrationOrganisation.id : null;
    delete applicant.charityRegistrationOrganisation;

    return ApplicantAPI.SaveApplicant(applicant).then(function(result) {
      vm.organisationInformationActive = false;
      vm.submitActive = true;
      $location.path("applicant-registration#submit");
      window.location.hash = "submit";
      var applicantId = result.id;
      if (applicantId)
        vm.applicantId = applicantId;
      AuthStore.refresh();
    });
  };

  vm.finalSubmitForm = function () {
    var dialog = ngDialog.open({
      template: require("./dialogs/submitmessage.pug")(),
      controller: require("./dialogs/submitmessage.js"),
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      resolve: {
        submit: function(){
          return function(){
            return vm.submitFinalForm().then(function() {
              window.location = "/applicant/dashboard/applications";
            })
          }
        }
      }
    });
  }

  vm.saveForLater = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/saveForLater.pug")(),
      controller: require("./dialogs/saveForLater.js"),
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      resolve: {
        submit: function() {
          return function() {
            return vm.submitForm().then(function() {
              window.location = "/account";
            })
          }
        }
      }
    });
  }

  vm.init = function() {

    vm.clearNav();
    //TODO: busy flag
    CharityRegistrationOrganisationsAPI.GetCharityRegistrationOrganisations().then(function(result) {
      vm.charityRegistrationOrganisations = result.results;
    });


    return Promise.join(
      UserAPI.GetCurrentUserInformation(),
      ApplicantAPI.GetApplicantDetails(),
      ApplicantLegalStatusAPI.GetApplicantLegalStatusTypes(),

      function(userDets, appDetails, legalStatusTypes){
        vm.applicantOrgStatusTypes = legalStatusTypes.results;

        if(appDetails){
          vm.applicantId = appDetails.applicantId;
          appDetails.recentBankStatement = appDetails.bankStatement;
          vm.organisationInformation = appDetails;
          vm.organisationInformation.position = userDets.organisationPosition
        }
      }
    );

    vm.organisationInformation.socialLinks = []
  };

  vm.init();

  vm.addGeo = function(e){
    e.preventDefault();
    var dialog = ngDialog.open(Geo.Dialog({value: vm.organisationInformation.areaServed, defaultToPlaces: true}));

    dialog.closePromise.then(function(obj) {
      if (obj.value.action == "cancel") return;
      if (obj.value.action == "save") {
        vm.organisationInformation.areaServed = obj.value.value;
      }
    })
  }

  vm.addCategory = function(e){
    e.preventDefault();
    var dialog = ngDialog.open(Category.Dialog({value: vm.organisationInformation.charitableCategories}));

    dialog.closePromise.then(function(obj) {
      if (obj.value.action == "cancel") return;
      if (obj.value.action == "save") {
        vm.organisationInformation.charitableCategories = obj.value.value;
      }
    })
  }

  vm.annualAccountsDocChanged = function(request){
    var aaDoc = request.annualAccounts;
    request.annualAccounts.blobId = aaDoc.id;
  }

  vm.businessPlanDocChanged = function(request){
    var bpDoc = request.businessPlans;
    request.businessPlans.blobId = bpDoc.id;
  }

  vm.recentBankStatementDocChanged = function(request){
    var rbsDoc = request.recentBankStatement;
    request.recentBankStatement.blobId = rbsDoc.id;
  }
};
